//
// DepotConfiguration.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/TransportModel";
import "./DeviceInfo";
import "../models/media/particles/ReportDataLevel";
import "../models/media/particles/CSSAdapter";
import "../models/media/particles/ReportImageSize";
import "../models/media/particles/Capability";
import "../models/media/particles/ReportImageType";

var DepotConfiguration = createModule("transport::DepotConfiguration", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        reportSchemaCheckFrequency: 4,
        clientid: 7,
        shouldPerformPeriodicReportDataChecks: 2,
        reportDataCreateWaitTime: 5,
        supportsViya4Servers: 2,
        userCacheSize: 4,
        generateReportImagesInterval: 5,
        shouldAllowAuditActivityService: 2,
        expandedFolderReportCacheLimit: 4,
        shouldAutoDeleteInsightAtSync: 2,
        reportSectionImageDefaultSize: 4,
        generateReportDataLevel: 4,
        shouldAutoRefreshCollections: 2,
        shouldAutoRefreshSharedItems: 2,
        shouldAutoCleanupSubscribedFolderBasedReportSubscriptions: 2,
        useHighContrastReportStyle: 2,
        supportsTransportServerLogging: 2,
        shouldUseCatalogSearchViewModels: 2,
        maximumShareEntries: 4,
        maximumNumberOfConcurrentReportDownloads: 4,
        cacheDirectoryPath: 7,
        passwordKeyChainGroup: 7,
        shouldAllowEsriSsoSupport: 2,
        shouldDownloadAvatarsForComments: 2,
        shouldAllowAdditionalFolderObjects: 2,
        deviceCheckFrequency: 4,
        maximumInsights: 4,
        shouldDoConnectionKeepAlive: 2,
        shouldDownloadReportImagesOnSubscribe: 2,
        credentialKeyChainGroup: 7,
        checkForSearchSupport: 2,
        useLastAccessDefaultUserWhenUsernameUnknown: 2,
        cssAdapter: 4,
        allowFutureServers: 2,
        reportDataCheckWaitTime: 5,
        generateReportTimeout: 4,
        downloadedReportImageSubdirectory: 7,
        generateReportStatusTimeout: 4,
        autoUpdateFrequency: 4,
        shouldAllowFolderSubscription: 2,
        connectionSubdirectory: 7,
        shouldAutoRefreshHistory: 2,
        wipePasswords: 2,
        shouldGetFeatureFlagsOnAuth: 2,
        reportImageDefaultSize: 4,
        reportSubdirectory: 7,
        shouldAutoSyncInsights: 2,
        shouldUseCatalogSearchApi: 2,
        reportImageSizes: [4],
        shouldPerformPeriodicDeviceChecks: 2,
        supportsTethered: 2,
        delayEventsAtStartup: 2,
        printFilesSubdirectory: 7,
        shouldAutoConnect: 2,
        generateReportStatusInterval: 4,
        connectionKeepAliveFrequency: 4,
        shouldPerformReportSchemaChecks: 2,
        shouldCheckForDataUpdatesOnOpen: 2,
        allowMetadataFailure: 2,
        isPrivateDataSupported: 2,
        reportImageCacheMaxFileCount: 4,
        generateReportImagesTimeout: 5,
        shouldUsePkceForOauth2: 2,
        persistentStorageDirectoryPath: 7,
        shouldEnforceOfflineLimit: 2,
        shouldAllowActivityService: 2,
        shouldAutoCleanupCollectionBasedReportSubscriptions: 2,
        shouldGetCatalogSearchSuggestions: 2,
        avatarRefreshPeriod: 4,
        auditid: 7,
        shouldAutoUpdateSubscribedReports: 2,
        avatarSubdirectory: 7,
        shouldAutoStartReportAssetDownloads: 2,
        reportDataCheckFrequency: 4,
        reportImageType: 4,
        maximumHistoryEntries: 4,
        deviceInfo: 1,
        insightSubdirectory: 7,
        shouldGetCadenceVersion: 2,
        sampleServerHostname: 7,
        enableUsernameLookupForSASDriveFile: 2,
        shouldAutoDownloadPrintedReports: 2,
        reportImageDownloadTimeout: 4,
        capabilityToCheckForAccess: 4,
        portfolioRefreshFrequency: 4,
        thumbnailSubdirectory: 7,
        shouldCheckForPrivateDataForSubscribedReports: 2,
        sasDriveSubdirectory: 7,
        reportImageCacheMaxTotalSize: 4,
        shouldGetTextSummaryOnSubscribe: 2,
        maximumNumberOfConcurrentAssetDownloadsPerReport: 4,
        checkForReportImagesSupport: 2,
        shouldAllowViya35WebLogon: 2,
        shouldAutoRefreshFavorites: 2,
        shouldPerformPeriodicReportUpdateChecks: 2,
        reportSectionImageSizes: [4],
        includeGuestAccountOnSecureStore: 2,
        shouldGeneratePreviewsOnDownload: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DepotConfiguration;
